/* Libs */
import styled from 'styled-components';


export const EditPOC = styled.div`
`;
